<template>
  <div
    class="column is-12 has-background-white--darken1 is-margin-left-xsmall"
    v-if="buildingLots && buildingLots.length">
    <div class="is-size-6 is-uppercase is-padding-bottom-xsmall">
      Lots concernés
    </div>
    <span
      class="tag is-primary is-margin-right-xsmall is-wAuto"
      v-for="lotBatiment in buildingLots"
      :key="lotBatiment.pk">
      <router-link
        :to="{name: 'LotVue', params: {id: lotBatiment.pk}}"
        class="has-text-white">
        {{ lotBatiment.ref }}
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    lots: Array,
    building: Object
  },
  computed: {
    buildingLots () {
      return this.lots.slice().filter(x => {
        if (x.building) return x.building.pk === this.building.pk
        else return false
      })
    }
  }
}
</script>
